export default __webpack_public_path__ + "static/graphql-2aaf50991c1a19dee5ec58065afac6d8.png";